import { Cradlepoint } from '@app/shared/models/cradlepoint/cradlepoint.model';
import { Location } from '@app/shared/models/location.model';

export class CradlepointLocation {
    public storeNumber: string;
    public cradlepoints: Cradlepoint[];
    public location: Location;
}